export default __webpack_public_path__ + "static/media/arrows-right.2f5cee2a.svg";